import { coreService } from "../../../services";

export interface YouTubeVideoMetadata {
  title: string;
  duration_in_seconds: number;
  thumbnail_url: string;
  youtube_url?: string;
}

const getYouTubeMetadata = async (
  url: string,
): Promise<YouTubeVideoMetadata> => {
  const response = await coreService.httpClient.get(
    `/episodes/youtube-metadata?url=${encodeURIComponent(url)}`,
    { withCredentials: true },
  );
  return response.data;
};

const importFromYouTube = async (payload: {
  youtube_url: string;
  name: string;
  project_id: string;
}): Promise<{ episode_id: string }> => {
  const response = await coreService.httpClient.post(
    "/episodes/import-from-youtube",
    payload,
    true,
  );
  return response.data;
};

export { getYouTubeMetadata, importFromYouTube };
